export const OPPORTUNITY_STATUS_LABELS: Record<string, string> = {
  prospection: "Prospection",
  qualification: "Qualification",
  proposal: "Proposition",
  negotiation: "Négociation",
  won: "Gagnée",
  lost: "Perdue",
  closed: "Clôturée",
};

export const DONATION_STATUS_LABELS: Record<string, string> = {
  promised: "Promesse",
  received: "Encaissé",
  cancelled: "Annulé",
};

export const RECURRING_STATUS_LABELS: Record<string, string> = {
  active: "Actif",
  suspended: "Suspendu",
  completed: "Terminé",
};

export const INSTALLMENT_STATUS_LABELS: Record<string, string> = {
  expected: "Attendu",
  received: "Reçu",
  cancelled: "Annulé",
};

export const FREQUENCY_LABELS: Record<string, string> = {
  monthly: "Mensuel",
  quarterly: "Trimestriel",
  yearly: "Annuel",
};

export const CAMPAIGN_TYPE_LABELS: Record<string, string> = {
  fundraising: "Collecte",
  awareness: "Sensibilisation",
  event: "Événement",
  emergency: "Urgence",
};

export const OVERDUE_TIER_LABELS: Record<string, string> = {
  en_attente: "En attente",
  en_retard: "En retard",
  perdue: "Perdue",
};

// Badge variant mapping for shadcn Badge component
export const STATUS_BADGE_VARIANT: Record<string, "default" | "secondary" | "destructive" | "outline"> = {
  // Opportunity
  prospection: "outline",
  qualification: "secondary",
  proposal: "secondary",
  negotiation: "secondary",
  won: "default",
  lost: "destructive",
  closed: "outline",
  // Donation
  promised: "outline",
  received: "default",
  cancelled: "destructive",
  // Recurring
  active: "default",
  suspended: "secondary",
  completed: "outline",
  // Installment
  expected: "outline",
};

// Overdue badge colors (Tailwind classes)
export const OVERDUE_TIER_COLORS: Record<string, string> = {
  en_attente: "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200",
  en_retard: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
  perdue: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};
